export enum EmailFrequencyEnum {
  INSTANTLY = 1,
  DAILY = 2,
  WEEKLY = 3,
  NEVER = 4,
}
